import React from 'react';
import { Link } from 'react-router-dom';

class ProjectListItem extends React.Component {
  render() {
    const { month } = this.props
    return (
      <Link to={`/month/${month.month}/${month.year}`} className="project-tile">
        <h4>{month.name}</h4>
      </Link>
    );
  }
}

export default ProjectListItem;



// WEBPACK FOOTER //
// ./src/components/MonthListItem.js